import { Link } from "react-router";

import { WorkThumb } from "../lib/WorkThumb.tsx";
import type { WorkCard } from "./collection.model.ts";
import { Tag } from "../lib/Tag.tsx";

/**
 * One work, photograph first — the same `WorkThumb` the dashboard strip uses,
 * so a card shows the same picture of the same work on both screens.
 *
 * The badge is the only status claim on the card, and it is the only one the
 * registry can make: whether an appointed authority signed the work off. There
 * is no IN COLLECTION / SOLD / TRANSFER IN PROGRESS here, because there is no
 * transfer in the schema to derive them from.
 *
 * The title links to the work's own record. That address is not a share: it
 * 403s for anyone without a grant, exactly as the collection does — see
 * useCollectorController for the rule that goes with it.
 */
export function WorkCardView({ card }: { card: WorkCard }) {
  return (
    <li className="collection__card">
      <WorkThumb imageUrl={card.imageUrl} title={card.title} />

      <div className="collection__card-body">
        <h3 className="collection__card-title">
          <Link to={card.href}>{card.title}</Link>
        </h3>
        <p className="collection__card-attribution">{card.attribution}</p>
        {card.medium && <p className="collection__card-medium">{card.medium}</p>}
      </div>

      <div className="collection__card-foot">
        <Tag tone={card.badge.kind}>{card.badge.label}</Tag>

        {card.location && (
          <span
            className={`collection__location${
              card.locationWithheld ? " collection__location--withheld" : ""
            }`}
          >
            {card.location}
          </span>
        )}

        <span className="collection__card-owner">
          {card.placement.collectionName} · {card.placement.owner.label}
        </span>
      </div>
    </li>
  );
}
